import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
	// load translation using xhr -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
	// learn more: https://github.com/i18next/i18next-xhr-backend
	.use(Backend)
	// detect user language
	// learn more: https://github.com/i18next/i18next-browser-languageDetector
	.use(LanguageDetector)
	// pass the i18n instance to react-i18next.
	.use(initReactI18next)
	.init({
		ns: [
			'global',
			'form',
			'listing',
			'error',
			'modals',
			'routes',
			'localizationSettings',
			'mediaSettings',
			'notifications',
		],
		whitelist: ['EN', 'RU'],
		interpolation: { escapeValue: false },
		nsSeparator: false,
		debug: false,
		fallbackLng: 'EN',
		defaultNS: 'global',
		react: {
			useSuspense: true,
		},
		backend: {
			loadPath: '/locales/{{lng}}/{{ns}}.json',
		},
	});

export default i18n;
